export const computeFuelTypeURL = ({ value }) => {
    const keyword = value.toLowerCase().split(" ").join("-");
    return [keyword, "cars"];
};
